import { useSelector } from "react-redux";
import { analytics } from "rtr-constants";
import UserProductRatingsContainer from "../user_product_ratings/user-product-ratings-container";
import OriginalPrice from "./pricing/original-pricing";
import ClearancePrice from "./pricing/clearance-pricing";
import ReservePrice from "./pricing/reserve-pricing";
import PropTypes from "prop-types";

const Header = ({ showComingSoonShortList = false }) => {
  const staticProduct = useSelector(state => state.staticProduct);
  const buyBoxMode = useSelector(state => state.pdpBuyBoxMode);
  const { designerId, designerDisplayName: designerName, displayName: styleName } = staticProduct;

  const isClearance = buyBoxMode === "clearance";
  const isReserve = buyBoxMode === "reserve";
  const clearancePricingLoaded = useSelector(state => state.pdp?.clearance?.pricing?.loaded);
  const reservePricingLoaded = useSelector(state => state.pdp?.reserve?.pricingLoaded);

  return (
    <div data-test-id="pdp-header" className="pdp-header">
      <div>
        <div className="flex justify-between items-center">
          <h1 className="font-sans text-md text-darkerGray pb-2" itemProp="name" aria-label="Product Name">
            {styleName}
          </h1>
          <div className="product-rating-container__wrapper -mr-3 -mt-2">
            <UserProductRatingsContainer
              product={staticProduct}
              location={analytics.ACTION_LOCATIONS.PDP}
              showComingSoonShortList={showComingSoonShortList}
            />
          </div>
        </div>

        <h2 className="font-sans text-h4 underline pb-2">
          <a href={"/designers/" + designerId + "?source=pdp"}>{designerName}</a>
        </h2>

        {isClearance && !clearancePricingLoaded ? null : isClearance ? (
          <ClearancePrice />
        ) : isReserve && !reservePricingLoaded ? null : isReserve ? (
          <ReservePrice />
        ) : (
          <OriginalPrice />
        )}
      </div>
    </div>
  );
};

Header.propTypes = {
  showComingSoonShortList: PropTypes.bool,
};

export default Header;
